import type { CommissionRuleDetail, CommissionRulePreview } from './types';

export const commissionRuleActorId = '00000000-0000-4000-8000-000000000001';
export const commissionRulePartnerId = '00000000-0000-4000-8000-000000000101';
export const commissionRuleGameId = '00000000-0000-4000-8000-000000000911';
export const commissionRuleId = '00000000-0000-4000-8000-000000000701';
export const commissionRulePreviewHash = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa';

const game: CommissionRuleDetail['game'] = {
  id: commissionRuleGameId,
  gameType: {
    id: '00000000-0000-4000-8000-000000000901',
    code: 'SLOT',
    name: 'Slots',
    status: 'ACTIVE',
  },
  code: 'SLOT-ROYAL',
  name: 'Royal Slot',
  status: 'ACTIVE',
  effectiveStatus: 'ACTIVE',
  dependencyBlockers: [],
  createdAt: '2026-07-20T10:00:00+07:00',
  createdBy: commissionRuleActorId,
  updatedAt: '2026-07-22T12:00:00+07:00',
  updatedBy: commissionRuleActorId,
};

export const commissionRuleFixtures: readonly CommissionRuleDetail[] = [
  {
    id: commissionRuleId,
    scope: 'PARTNER',
    partnerId: commissionRulePartnerId,
    gameId: commissionRuleGameId,
    game,
    activationMode: 'SCHEDULED',
    version: 2,
    agentRatePercent: '10.000000',
    affiliateRatePercent: '3.000000',
    effectiveFrom: '2026-08-01T00:00:00+07:00',
    effectiveTo: null,
    lifecycle: 'DRAFT',
    phase: 'DRAFT',
    effective: false,
    dependencyBlockers: [],
    createdAt: '2026-07-23T10:00:00+07:00',
    createdBy: commissionRuleActorId,
    publishedAt: null,
    publishedBy: null,
    cancelledAt: null,
    cancelledBy: null,
    cancellationReason: null,
  },
  {
    id: '00000000-0000-4000-8000-000000000702',
    scope: 'GLOBAL',
    partnerId: null,
    gameId: commissionRuleGameId,
    game,
    activationMode: 'IMMEDIATE',
    version: 1,
    agentRatePercent: '8.500000',
    affiliateRatePercent: '2.500000',
    effectiveFrom: '2026-06-01T00:00:00+07:00',
    effectiveTo: null,
    lifecycle: 'PUBLISHED',
    phase: 'ACTIVE',
    effective: true,
    dependencyBlockers: ['REFERENCED_BY_TRANSACTIONS'],
    createdAt: '2026-05-20T09:00:00+07:00',
    createdBy: commissionRuleActorId,
    publishedAt: '2026-05-21T09:00:00+07:00',
    publishedBy: commissionRuleActorId,
    cancelledAt: null,
    cancelledBy: null,
    cancellationReason: null,
  },
];

export function createCommissionRulePreview(
  input: {
    readonly scope: 'GLOBAL' | 'PARTNER';
    readonly partnerId?: string | null;
    readonly gameId: string;
    readonly activationMode: 'IMMEDIATE' | 'SCHEDULED';
    readonly effectiveFrom?: string | null;
    readonly effectiveTo?: string | null;
    readonly agentRatePercent: string;
    readonly affiliateRatePercent: string;
    readonly sampleActualPlayAmount: string;
    readonly sampleCurrencyCode: string;
  },
  overlap = false,
): CommissionRulePreview {
  const play = Number(input.sampleActualPlayAmount);
  const agent = (play * Number(input.agentRatePercent)) / 100;
  const affiliate = (play * Number(input.affiliateRatePercent)) / 100;
  return {
    configuration: {
      scope: input.scope,
      partnerId: input.scope === 'PARTNER' ? (input.partnerId ?? null) : null,
      gameId: input.gameId,
      activationMode: input.activationMode,
      effectiveFrom: input.effectiveFrom ?? null,
      effectiveTo: input.effectiveTo ?? null,
      agentRatePercent: input.agentRatePercent,
      affiliateRatePercent: input.affiliateRatePercent,
    },
    calculation: {
      currencyCode: input.sampleCurrencyCode,
      actualPlayAmount: input.sampleActualPlayAmount,
      agentCommissionUnrounded: agent.toFixed(8),
      affiliateCommissionUnrounded: affiliate.toFixed(8),
      agentCommission: agent.toFixed(2),
      affiliateCommission: affiliate.toFixed(2),
      totalCommission: (agent + affiliate).toFixed(2),
    },
    warnings: [{ code: 'PARTNER_IMPACT', message: 'Internal partner-impact calculation details' }],
    blockers: overlap
      ? [{ code: 'EFFECTIVE_PERIOD_OVERLAP', message: 'Internal overlap details' }]
      : [],
    impactedPartnerCount: input.scope === 'GLOBAL' ? 12 : 1,
    previewHash: commissionRulePreviewHash,
  };
}
